// Deliberately untyped parameter/return (matches the pre-existing sidebar `round` this was
// extracted from): the mixed number|string return needs to slot into ChipV2's `total` prop
// without widening that prop's type across every other caller that only ever passes a number.
export function roundCount(value) {
  if (value >= 1_000_000) return (value / 1_000_000).toFixed(0) + `m`
  if (value >= 1_000) return (value / 1_000).toFixed(0) + `k`
  return value
}
